export default __webpack_public_path__ + "static/media/cpcb.b529f75d.jpg";